import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { routes } from '../../routes/routes-names';
import footerlogo from '../../../assets/img/OfferX-white-footer.svg';
import { useRegistration } from '../../../components/registration/RegistrationContext';

const Footer = () => {
    const { resetAllState } = useRegistration();

    return (
        <footer className="landing-footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-8">
                        <img loading="lazy" src={footerlogo} className="site-logo mb-3" alt="OfferX Logo"></img>
                        <p className="fs-14 mb-3">
                            Join OfferX now and take the first step towards a<br className="hide-576" /> stable and
                            predictable hiring process.
                        </p>
                        <div className="offerx-footer-address">
                            {/* <a href="tel: +914048512310">
                                <i className="bi bi-telephone" /> +91 40 - 48512310
                            </a> */}
                            <a href="mailto: support@offerx.in" className="fs-12">
                                <i className="bi bi-envelope" /> support@offerx.in
                            </a>
                            <div className="d-flex mt-3">
                                <Link to={`${routes.signinSignup}`} type="button">
                                    <button className="btn btn-outline-white me-3">Sign in</button>
                                </Link>
                                <NavLink
                                    to={routes.signUp}
                                    className={({ isActive }) => (isActive ? 'active' : '')}
                                    onClick={resetAllState}
                                >
                                    <button className="btn btn-primary border-radius-3">Register</button>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <h4 className="mt-md-0 fs-16 fw-600 mb-3">Important Links</h4>
                        <ul className="offerx-footer-links">
                            <li>
                                <Link className="fw-400 fs-14 text-light me-2" to={routes.about}>
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link className="fw-400 fs-14 text-light me-2" to={routes.contact}>
                                    Contact Us
                                </Link>
                            </li>
                            {/* <li>
                                <a rel="noreferrer" href="https://www.graph5.com" target="_blank">
                                    Graph5
                                </a>
                            </li>
                            <li>
                                <a rel="noreferrer" href="https://www.screenx.ai/" target="_blank">
                                    ScreenX
                                </a>
                            </li> */}
                            <li>
                                <Link className="fw-400 fs-14 text-light me-2" to={routes.faq}>
                                    FAQ's
                                </Link>
                            </li>
                            <li>
                                <Link className="fw-400 fs-14 text-light me-2" to={routes.privacy}>
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link className="fw-400 fs-14 text-light me-2" to={routes.terms}>
                                    Terms & Conditions
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <h4 className="fs-16 fw-600 mb-3">Social Media</h4>
                        <div className="offerx-social-icons mb-3">
                            <a
                                rel="noreferrer"
                                href="https://www.facebook.com/OfferX.india"
                                target="_blank"
                                title="Facebook"
                            >
                                <i className="bi bi-facebook" />
                            </a>
                            <a rel="noreferrer" href="https://www.twitter.com/OfferX_" target="_blank" title="Twitter">
                                <i className="bi bi-twitter-x" />
                            </a>
                            <a
                                rel="noreferrer"
                                href="https://www.linkedin.com/company/offer-x"
                                target="_blank"
                                title="Linkedin"
                            >
                                <i className="bi bi-linkedin" />
                            </a>
                            <a
                                rel="noreferrer"
                                href="https://www.instagram.com/offerx.global"
                                target="_blank"
                                title="Instagram"
                            >
                                <i className="bi bi-instagram" />
                            </a>
                        </div>
                        <p className="mb-3 fs-12">
                            Copyright © {new Date().getFullYear()} OfferX.in
                            <br />
                            All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
